import React from 'react';
import MenuBar from '../Component/MenuBar.jsx';
import PageBanner from '../Component/PageBanner';
import Sidebar from '../Component/Sidebar';
import Footer from '../Component/Footer';
import { Link } from 'react-router-dom';

// import "../..//asstes/css/sass/programs-rituals.css";






export default function InaugurationEvents() {
    const eventday = {
        border: "1px solid rgb(244 193 37)",
        borderRadius: "4px",
        padding: "5px",
        marginBottom: "5px",

    };

    const eventdayheading = {
        backgroundColor: "rgb(244 193 37)",

        fontSize: "20px"
    };


    const eventheading = {

        fontSize: "22px"

    }


    return (

        <>
            <MenuBar />
            <Sidebar />

            {/* <!-- Page Banner Section --> */}
            <PageBanner title="Upcoming Events" />




            {/* <!--FAQs Section--> */}
            <section className="faq-section">
                <div className="auto-container">

                    <div className="row clearfix">

                        <div className="col-md-12">

                            <h1 className="text-center ">Grand Inauguration of Yugal Kunj</h1>
                            <h4 className="text-center">Saturday, May 17th to Monday, May 19th</h4>

                            <hr />



                            <div className="panel panel-primary">
                                <div className="panel panel-heading">

                                    <h4>Inauguration Events</h4>
                                </div>


                                <div className="panel panel-body">
                                    <div className="inner-heading">
                                        <p className="text-center">
                                            <span>
                                                <Link
                                                    to="https://ykportal.yugalkunj.org/?ParamCountry=Canada"
                                                    className="theme-btn btn-style-one"
                                                    target="_blank"
                                                >
                                                    <span className="btn-title" style={{ fontSize: "22px" }}>
                                                        <i className="fa fa-user" style={{ fontSize: "22px" }}></i> To register please click here
                                                    </span>
                                                </Link>
                                            </span>

                                            <span> &nbsp;</span>
                                            <span>
                                                <Link
                                                    to="https://inauguration-donation.yugalkunj.org/"
                                                    className="theme-btn btn-style-one"
                                                    target="_blank"
                                                >
                                                    <span className="btn-title" style={{ backgroundColor: "green", fontSize: "22px", marginRight: "5px" }}>
                                                        <i className="fa fa-dollar-sign" style={{ fontSize: "22px" }}></i> Donation Opportunity
                                                    </span>
                                                </Link>
                                            </span>
                                        </p>


                                        <div className="inner_heading_title purple-border">
                                            <h4> View Flyer</h4>

                                            <figure style={{ padding: '10px' }}>
                                                <img src='https://yugalkunj.org/images/YUGAL%20KUNJ%20CANADA%201.jpg' className='img-responsive' />
                                                <img src='https://yugalkunj.org/images/YUGAL%20KUNJ%20CANADA%202.jpg' className='img-responsive' />
                                                <img src='https://yugalkunj.org/images/YUGAL%20KUNJ%20CANADA%203.jpg' className='img-responsive' />
                                                <img src='https://yugalkunj.org/images/YUGAL%20KUNJ%20CANADA%204.jpg' className='img-responsive' />


                                                {/* <iframe
                                                  src="https://yugalkunj.org/images/YUGAL%20KUNJ%20CANADA%20PRAN%20PRATISHTHA.pdf"
                                                  width="100%"
                                                  height="1000px"
                                                  style={{ border: "none" }}
                                              ></iframe> */}
                                            </figure>
                                        </div>


                                        {/* <div className="inner_heading_title purple-border">
                                            <h4> Who Are We?  </h4>

                                           

                                            <div className="text">
                                                <p> Yugal Kunj is the most prominent Hindu temple and ashram in Hamilton. All souls, regardless of their faith and belief, are welcome here. The purpose of Yugal Kunj is to promote Bhakti, devotion of Radha Krishna described in the ancient Vedic scriptures of India, as taught by Jagadguru Shri Kripalu Ji Maharaj.</p>
                                                <p> In addition to devotional development, Yugal Kunj is committed to various activities to improve the welfare of society, in turn aiding spiritual upliftment. We offer a large variety of classes and seminars which include: dholak, tabla, vocals and dance classes, Gurukul classes for children between the ages 3 - 15, seniors cyber-literacy seminars, cooking classes and much more!  </p>
                                              
                                                <p> We run weekly satsangs which take place every Saturday from 10am to 12:30pm followed by delicious satvik lunch prasad. We invite you to join and be a valuable part of an exciting new, ever-growing community!</p>

                                              

                                           
                                            </div>

                                        </div> */}



                                        <div className="inner_heading_title orange-border" style={{ marginTop: '10px' }}>


                                            <div className="text">





                                                <ul className="satsang_list">

                                                    <li> <strong> Ganapati Pooja:</strong> An essential ritual to invoke the blessings of Lord Ganesh for a successful inauguration.</li>
                                                    <li>
                                                        <strong> Kumbh Sthapana: </strong> Installation of sacred kalashas energized with divine vibrations.
                                                    </li>
                                                    <li>
                                                        <strong>  Kalash Pooja:</strong>  Invoking divine energies into a sacred water pot for spiritual presence.
                                                    </li>

                                                    <li>  <strong> Vastu Shanti:</strong> A ritual ensuring the temple aligns with Vastu Shastra principles.</li>
                                                    <li>  <strong>  Mangal Snan:</strong> Sacred bathing of the deity idol before consecration..</li>
                                                    <li>  <strong>  Pran Prathishtha:</strong> The act of invoking divine presence into the deity.</li>
                                                    <li> <strong> Jal Yatra: </strong> A procession of sacred water collected from holy rivers.</li>
                                                    <li> <strong> Ling Sthapana: </strong>  Installation of a Shiv Ling to invoke Lord Shiva's presence.</li>
                                                    {/* <li> <strong> Ling Sthapana: </strong>  Installation of a Shiv Ling to invoke Lord Shiva's presence.</li> */}
                                                    <li> <strong> Pind Poojan: </strong>   Honoring ancestors and seeking their blessings.</li>
                                                    <li> <strong> Navagrah Havan: </strong>  A fire ritual to appease planetary deities for prosperity.</li>
                                                    <li> <strong> Maha Abhishek: </strong> A grand ceremonial bathing of the deities.</li>
                                                    <li> <strong> Alankar Darshan: </strong> Viewing of deities in their full adornment.</li>
                                                    <li> <strong> Shobha Yatra: </strong> A grand procession celebrating the inauguration.</li>









                                                </ul>
                                            </div>

                                        </div>






                                        <div className="inner_heading_title purple-border">
                                            <h4> Programs & Rituals </h4>

                                            <div className="text">

                                                <div className="container">

                                                    {/* <!-- Day 1 --> */}
                                                    <div className="row" style={eventday}>
                                                        <div className="column col-md-4" >
                                                            <h3 style={eventheading} >Day 1 - Purification & Invocations</h3>
                                                            <p><span className="bold">5:00-6:00am:</span> Ganpati Pooja, Daan Sankalp</p>
                                                            <p><span className="bold">6:00-7:00am:</span> Kumbha Sthapana, Kalash Pooja, Vastu Shanti</p>
                                                            <p><span className="bold">7:00-8:00am:</span> Morning Aarti, Bhog & Breakfast</p>
                                                            <p><span className="bold">8:00-11:00am:</span> Mangal Snaan, Jal Yaatra, Ling Sthapana, Pind Poojan</p>
                                                            <p><span className="bold">11:00am-12:00pm:</span> Pradhana Devta Avahan, Mandal Pooja</p>
                                                            <p><span className="bold">12:00-1:30pm:</span> Maha Prasad (Lunch)</p>
                                                        </div>
                                                        <div className="column col-md-4">
                                                            <h3 style={eventheading} >Saturday, May 17</h3>
                                                            <p><span className="bold">1:30-3:30pm:</span> Navagraha Havan</p>
                                                            <p><span className="bold">3:30-4:00pm:</span> Tea & Snacks</p>
                                                            <p><span className="bold">4:00-5:00pm:</span> Live Spiritual Discourse</p>
                                                            <p><span className="bold">5:00-7:00pm:</span> Cultural Program, Deep Aradhana, Shayanotsav</p>
                                                            <p><span className="bold">7:00-8:00pm:</span> Shayan Aarti, Bhog & Dinner Prasad</p>
                                                        </div>
                                                        <div className="column col-md-4">
                                                            <h3 style={eventheading}>Sankeertan</h3>
                                                            <p><span className="bold">6:00-7:00am</span></p>
                                                            <p><span className="bold">10:00am-12:00pm</span></p>
                                                        </div>
                                                    </div>

                                                    {/* <!-- Day 2 --> */}
                                                    <div className="row" style={eventday}>
                                                        <div className="column col-md-4">
                                                            <h3 style={eventheading}>Day 2 - Pran Pratishthapan</h3>
                                                            <p><span className="bold">5:00-7:00am:</span> Das Adhivas, Nav Kalash Abhishek</p>
                                                            <p><span className="bold">7:00-8:00am:</span> Morning Aarti, Bhog & Breakfast</p>
                                                            <p><span className="bold">8:00-10:00am:</span> Pran Pratishthapan</p>
                                                            <p><span className="bold">10:00am-12:00pm:</span> Maha Abhishek, Alankar Darshan</p>
                                                            <p><span className="bold">12:00-1:30pm:</span> Maha Prasad (Lunch)</p>
                                                        </div>
                                                        <div className="column col-md-4">
                                                            <h3 style={eventheading}>Sunday, May 18</h3>
                                                            <p><span className="bold">2:00-3:30pm:</span> Shobha Yatra (Keertan Procession)</p>
                                                            <p><span className="bold">3:30-4:00pm:</span> Tea & Snacks</p>
                                                            <p><span className="bold">4:00-5:00pm:</span> Live Spiritual Discourse</p>
                                                            <p><span className="bold">5:00-7:00pm:</span> Sankeertan & Deep Aradhana</p>
                                                            <p><span className="bold">7:00-8:00pm:</span> Shayanotsav, Aarti, Bhog & Dinner Prasad</p>
                                                        </div>
                                                        <div className="column col-md-4">
                                                            <h3 style={eventheading}>Sankeertan</h3>
                                                            <p><span className="bold">6:00-7:00am</span></p>
                                                            <p><span className="bold">10:00am-12:00pm</span></p>
                                                        </div>
                                                    </div>

                                                    {/* <!-- Day 3 --> */}
                                                    <div className="row" style={eventday}>
                                                        <div className="column col-md-4" >
                                                            <h3 style={eventheading} >Day 3 - Completion Rituals & Celebrations</h3>
                                                            <p><span className="bold">6:00-8:00am:</span> Suprabhat Seva & Havan</p>
                                                            <p><span className="bold">8:00-10:00am:</span> Maha Kumbh Abhishek</p>
                                                            <p><span className="bold">10:00-11:30am:</span> Archana & Special Pooja</p>
                                                            <p><span className="bold">11:30am-1:00pm:</span> Grand Maha Aarti, Teerth Prasad</p>
                                                        </div>
                                                        <div className="column col-md-4">
                                                            <h3 style={eventheading} >Monday, May 19</h3>
                                                            <p><span className="bold">1:00-2:30pm:</span> Mahabhog & Lunch Prasad</p>
                                                            <p><span className="bold">3:00-5:00pm:</span> Live Spiritual Discourse & Sankeertan</p>
                                                            <p><span className="bold">5:00-6:00pm:</span> Rath Yatra (Chariot Procession)</p>
                                                            <p><span className="bold">6:30-8:00pm:</span> Grand Concluding Aarti, Bhog & Dinner Prasad</p>
                                                        </div>
                                                        <div className="column col-md-4">
                                                            <h3 style={eventheading} >Sankeertan</h3>
                                                            <p><span className="bold">6:00-8:00am</span></p>
                                                            <p><span className="bold">11:30am-1:00pm</span></p>
                                                        </div>
                                                    </div>

                                                </div>



                                            </div>

                                        </div>


                                        <div className="inner_heading_title purple-border">
                                            <h4> Accommodations</h4>

                                            <div className="text">

                                                {/* <p className="lead">Travel time: approx. one hour (depending on traffic)</p>
                                                <p className="lead">Travel cost: approx. $75</p>

                                                <p><strong>NOTE:</strong> You cannot schedule a ride with Uber or Lyft until you are ready to ride.  So schedule a ride only after you have picked up your luggage at Baggage claim and ready to exit the airport.</p> */}

                                                <ul className="Number_list">

                                                    <li>Holiday Inn Express: 1276 Upper James Street, Hamilton, ON L9C 3B4</li>
                                                    <li>Visitors Inn: 649 Main Street West, Hamilton, ON L8S 1A2</li>
                                                    {/* <li>Staybridge Suites: 20 Caroline St S, Hamilton, ON L8P 0B1</li> */}



                                                </ul>
                                            </div>

                                        </div>






                                        <div className="inner_heading_title orange-border">
                                            <h4> How To Get To Yugal Kunj</h4>

                                            <div className="text">

                                                <ul className='satsang_list'>
                                                    <li>
                                                        From Pearson International Airport: Uber (~45 min) or Public Transit (~2 hours)
                                                    </li>
                                                    <li>
                                                        From Hamilton Airport: Uber (~45 min) or Public Transit (~1 hour)
                                                    </li>

                                                </ul>





















                                            </div>

                                        </div>




                                    </div>



                                </div>



                            </div>

                        </div>


                    </div>


                </div>
            </section>




            <Footer />
        </>


    )
}
